"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/LegalAgreements/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Form = require('web/components/Form');
var _components = require('web/screens/Signup/components');
var _AuthFrame = require('web/components/AuthFrame');
var _Tooltip = require('web/components/Tooltip');
var _supportUrls = require('shared/data/supportUrls');
var _baaText = require('./baaText'); var _baaText2 = _interopRequireDefault(_baaText);













const renderAcceptBlock = ({
  orgName, accepted, reachedEnd, isSubmitting, onAccept, onSubmit, onBack,
}



) => {
  const block = (
    _react2.default.createElement('div', { className: `legal-agreements--accept-block${reachedEnd ? '' : ' is-locked'}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
      ,  !reachedEnd && (
        _react2.default.createElement('p', { className: "legal-agreements--scroll-hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
          , _react2.default.createElement('svg', { viewBox: "0 0 24 24"   , width: "18", height: "18", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
            , _react2.default.createElement('path', { d: "M12 4v12M6 11l6 6 6-6M5 20h14"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} )
          ), "Scroll to the end of the agreement to enable acceptance."

        )
      ) 
      , _react2.default.createElement('label', { className: "legal-agreements--checkbox", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
        , _react2.default.createElement('input', {
          type: "checkbox",
          checked: accepted,
          disabled: !reachedEnd,
          onChange: event => onAccept(event.target.checked), __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
        )
        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, "I confirm I am authorized to bind "
                 , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, orgName), " to these agreements, including the"
            , ' '
          , _react2.default.createElement('a', { href: _supportUrls.termsUrl, target: "_blank", rel: "noopener noreferrer" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}, "Terms of Service"  ), "."
        )
      )
      , _react2.default.createElement('div', { className: "legal-agreements--actions signup-step--controls" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
        , _react2.default.createElement(_components.BackArrow, { onClick: onBack, disabled: isSubmitting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}} )
        , _react2.default.createElement(_Form.Button, { isDisabled: !accepted || isSubmitting, isLoading: isSubmitting, onClick: onSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "I accept"

        )
      )
    )
  )

  return (
    _react2.default.createElement('div', { className: "legal-agreements--accept-slot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
      ,  reachedEnd
        ? block
        : (
          _react2.default.createElement(_Tooltip.HoverTooltip, {
            type: "dark",
            place: "top",
            content: _react2.default.createElement(_Tooltip.TooltipHint, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, "Scroll to the bottom of the agreement first."       ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}

            ,  block 
          )
          ) 
    )
  )
}

const LegalAgreementsSection = ({
  orgName, accepted, onAccept, onSubmit, onBack, error,
}) => {
  const scrollRef = _react.useRef(null)
  const [isSubmitting, setIsSubmitting] = _react.useState.call(void 0, false)

  const submit = () => {
    const result = onSubmit()
    if (result && typeof (result ).then === 'function') {
      setIsSubmitting(true)
      ;(result ).finally(() => setIsSubmitting(false))
    }
  }
  // The attestation unlocks only after the full agreement has scrolled past.
  // A revisit that already holds acceptance stays unlocked — re-locking a
  // checked box would strand the user.
  const [reachedEnd, setReachedEnd] = _react.useState.call(void 0, accepted)

  const checkReachedEnd = () => {
    const el = scrollRef.current
    if (!el || reachedEnd) return
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 12) setReachedEnd(true)
  }
  // Content that fits without a scrollbar (or short viewports in tests)
  // counts as read on mount.
  _react.useEffect.call(void 0, checkReachedEnd, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    _react2.default.createElement('div', { className: "legal-agreements", __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}
      , _react2.default.createElement('section', { className: "legal-agreements--acceptance", __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}
        , _react2.default.createElement('h1', { className: "auth-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}, "Review and accept"  )
        , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}, "Before creating your organization, please review the Business Associate Agreement and BloomText Terms of Service."


        )
        , _react2.default.createElement('p', { className: "auth-small legal-agreements--email-note" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}, "We'll email a final copy of the agreement to you."

        )
        ,  error && _react2.default.createElement(_AuthFrame.Callout, { message: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}} ) 
      )
       /* Unread state carries a soft highlight that steers the eye to the
           document before the (dimmed) accept controls. In the collapsed
           single-column layout the DOM order is the reading order: intro →
           agreement → accept. */ 
      , _react2.default.createElement('section', {
        className: `legal-agreements--scroll${reachedEnd ? '' : ' is-unread'}`,
        'aria-label': "Business Associate Agreement"  ,
        // Focusable, so a keyboard alone can scroll it to the end and unlock
        // acceptance.
        tabIndex: 0,
        ref: scrollRef,
        onScroll: checkReachedEnd, __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}

        , _react2.default.createElement(_baaText2.default, { orgName: orgName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}} )
      )
      ,  renderAcceptBlock({
        orgName, accepted, reachedEnd, isSubmitting, onAccept, onSubmit: submit, onBack,
      }) 
    )
  )
}

exports. default = LegalAgreementsSection
